module.exports = __webpack_public_path__ + "static/media/photo12.701e174a.png";